module.exports = __webpack_public_path__ + "img/Hongkong.bcd572f4.jpg";